import React, { useEffect } from "react";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import DialogBox from "../../../components/UI/DialogBox";
import spin from "../../../assets/icons/spin.png";
import { SITE_SETUP } from "../apiEndpoints";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import SiteTabsContainer from "../forms/addSite/SiteTabsContainer"

const AddSitePage = () => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(SITE_SETUP);
  }, []);

  return (
    <MainPageLayout headerConfig={{ title: "Add Site" }}>
      {isLoaded && !error ? (
        <SiteTabsContainer siteSetup={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading your data" animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default AddSitePage;
